export const config = {
  title: "RHH General Construction LLC | Renovations, Painting & Fencing in Jacksonville, FL",
  meta: {
    description:
      "RHH General Construction LLC provides expert bathroom and kitchen renovations, general remodeling, fencing, and interior & exterior painting in Jacksonville, FL.",
    keywords: [
      "RHH General Construction LLC",
      "bathroom renovations Jacksonville",
      "kitchen remodeling Jacksonville",
      "home renovations FL",
      "fencing Jacksonville",
      "interior painting Jacksonville",
      "exterior painting Jacksonville"
    ],
    author: "RHH General Construction LLC",
    canonicalUrl: "https://fl-fencecontractor.com/",
  },
  sections: {
    header: {
      businessName: "RHH General Construction LLC",
    },
    sectionB: {
      heroTitle: "Transforming Homes Inside & Out",
      heroSubtitle: "Expert Renovations, Painting, and Fencing in Jacksonville, FL",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "9043448244",
      phoneLabel: "(904) 344-8244",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2225598052/photo/housebuilding-progress-on-new-estate.jpg?s=612x612&w=0&k=20&c=nBFnLVy6N50AiwVyidE-XPq_znIfaqepPPg6rTAGTUE=",
      cardData: [
        {
          title: "Bathroom Renovations",
          description:
            "Upgrade your bathroom with modern designs, fixtures, and finishes.",
        },
        {
          title: "Kitchen Remodeling",
          description:
            "Transform your kitchen into a functional and stylish space.",
        },
        {
          title: "Painting & Fencing",
          description:
            "Interior & exterior painting plus durable fencing solutions.",
        },
      ],
      description:
        "At RHH General Construction LLC, we specialize in bathroom and kitchen renovations, interior and exterior house painting, fencing, and general remodeling services throughout Jacksonville, FL.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We offer a wide range of construction and renovation services to improve the look, comfort, and value of your home.",
      cards: [
        {
          title: "Bathroom Renovations",
          description:
            "Modern upgrades, tiling, plumbing fixtures, and custom designs.",
          imageSrc: "https://media.istockphoto.com/id/679511934/photo/construction-worker-installing-small-ceramic-tiles-on-bathroom-walls-and-applying-mortar-with.jpg?s=612x612&w=0&k=20&c=wV24ugzHyJVLGKRMEWtse_NggcbaJTHZ6vLTf3h1jqI=",
          imageAlt: "Bathroom Renovation",
        },
        {
          title: "Kitchen Remodeling",
          description:
            "Cabinetry, countertops, flooring, and complete kitchen makeovers.",
          imageSrc: "https://media.istockphoto.com/id/1466145748/photo/kitchen-fitters-installing-some-cabinets.jpg?s=612x612&w=0&k=20&c=AtAGBHY6KWbf-HjoPrhGDNybh4-zqDF2OebNezuO3do=",
          imageAlt: "Kitchen Remodeling",
        },
        {
          title: "Interior & Exterior Painting",
          description:
            "Professional painting services to refresh and protect your home.",
          imageSrc: "https://media.istockphoto.com/id/1312114883/photo/mature-painter-painting-a-wall.jpg?s=612x612&w=0&k=20&c=t-afZ_AqE2YBkVrpc2VxAGtFfXpySDYrCOgLznO5cTk=",
          imageAlt: "Interior Painting",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "General Renovations",
        "Exterior House Painting",
        "Residential Fencing",
        "Home Repairs",
        "Custom Projects",
      ],
    },
    sectionD: {
      aboutTitle: "About RHH General Construction LLC",
      aboutImage: {
        src: "https://fl-fencecontractor.com/wp-content/uploads/2025/09/Gate-Installation.webp",
        alt: "RHH General Construction Team",
      },
      aboutText: [
        "RHH General Construction LLC is a Jacksonville-based company providing top-quality renovation and construction services for residential properties.",
        "From bathroom and kitchen remodels to painting and fencing, we pride ourselves on delivering reliable craftsmanship and customer satisfaction.",
      ],
    },
    sectionE: {
      profileImage: "https://fl-fencecontractor.com/wp-content/uploads/2024/12/fence-logo.webp",
      profileAlt: "RHH General Construction LLC Logo",
      businessName: "RHH General Construction LLC",
      contact: {
        phone: "9043448244",
        phoneLabel: "(904) 344-8244",
        email: "rhh.generalconstructionllc@gmail.com",
        website: "https://fl-fencecontractor.com/",
        address: "Jacksonville, FL 32211, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Jacksonville, FL 32211, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d344352.8854568188!2d-81.8011786934106!3d30.348898058990888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e5b84b9a3a6f71%3A0xa01384a30d3f9f01!2sJacksonville%2C%20FL%2032211!5e0!3m2!1sen!2sus!4v1694452800000!5m2!1sen!2sus",
    },
  },
};

export default config;
